import React from "react";

const PublicRoute = ({ children }) => {
  return children;
};

export default PublicRoute;
